import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93acc1f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-4 shadow p-4 mb-5 text-break"
}
const _hoisted_2 = { class: "fw-bold fs-6 mb-4" }
const _hoisted_3 = { class: "bg-gray fw-bold fs-6 p-3 mt-5" }
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = {
  key: 0,
  class: "col-9"
}
const _hoisted_8 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = {
  key: 0,
  class: "col-9"
}
const _hoisted_11 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = { class: "col-9" }
const _hoisted_14 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "col-9" }
const _hoisted_17 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = { class: "col-9" }
const _hoisted_20 = {
  key: 0,
  class: "row mb-2 p-3 fs-7"
}
const _hoisted_21 = { class: "col-3" }
const _hoisted_22 = { class: "col-9" }
const _hoisted_23 = {
  key: 1,
  class: "row mb-2 p-3 fs-7"
}
const _hoisted_24 = { class: "col-3" }
const _hoisted_25 = {
  key: 0,
  class: "col-9"
}
const _hoisted_26 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_27 = { class: "col-3" }
const _hoisted_28 = { class: "col-9" }
const _hoisted_29 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_30 = { class: "col-3" }
const _hoisted_31 = { class: "col-9" }
const _hoisted_32 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_33 = { class: "col-3" }
const _hoisted_34 = {
  key: 0,
  class: "col-9"
}
const _hoisted_35 = { class: "bg-gray fw-bold fs-6 p-3" }
const _hoisted_36 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_37 = { class: "col-3" }
const _hoisted_38 = { class: "col-9" }
const _hoisted_39 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_40 = { class: "col-3" }
const _hoisted_41 = { class: "col-9" }
const _hoisted_42 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_43 = { class: "col-3" }
const _hoisted_44 = { class: "col-9" }
const _hoisted_45 = { class: "bg-gray fw-bold fs-6 p-3" }
const _hoisted_46 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_47 = { class: "col-3" }
const _hoisted_48 = { class: "col-9 d-flex align-items-center" }
const _hoisted_49 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_50 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_51 = {
  key: 2,
  class: "mt-1"
}
const _hoisted_52 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_53 = { class: "row mb-2 p-3 fs-7" }
const _hoisted_54 = { class: "col-3" }
const _hoisted_55 = { class: "col-9" }
const _hoisted_56 = { class: "bg-gray fw-bold fs-6 p-3" }
const _hoisted_57 = { class: "row fs-7 mb-5" }
const _hoisted_58 = { class: "col-lg-6" }
const _hoisted_59 = {
  key: 0,
  class: "row corporation ps-3"
}
const _hoisted_60 = { class: "col-lg-6" }
const _hoisted_61 = { class: "col-lg-6" }
const _hoisted_62 = {
  key: 1,
  class: "row corporation ps-3"
}
const _hoisted_63 = { class: "col-lg-6" }
const _hoisted_64 = { class: "col-lg-6" }
const _hoisted_65 = {
  key: 2,
  class: "row corporation ps-3"
}
const _hoisted_66 = { class: "col-lg-6" }
const _hoisted_67 = { class: "col-lg-6" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 3,
  class: "row corporation ps-3"
}
const _hoisted_70 = { class: "col-lg-6" }
const _hoisted_71 = { class: "col-lg-6" }
const _hoisted_72 = {
  key: 4,
  class: "row corporation ps-3"
}
const _hoisted_73 = { class: "col-lg-6" }
const _hoisted_74 = { class: "col-lg-6" }
const _hoisted_75 = {
  key: 5,
  class: "row corporation ps-3"
}
const _hoisted_76 = { class: "col-lg-6" }
const _hoisted_77 = { class: "col-lg-6" }
const _hoisted_78 = { class: "col-lg-6" }
const _hoisted_79 = {
  key: 0,
  class: "row school"
}
const _hoisted_80 = { class: "col-lg-6" }
const _hoisted_81 = { class: "col-lg-6" }
const _hoisted_82 = {
  key: 1,
  class: "row school"
}
const _hoisted_83 = { class: "col-lg-6" }
const _hoisted_84 = { class: "col-lg-6" }
const _hoisted_85 = {
  key: 2,
  class: "row school"
}
const _hoisted_86 = { class: "col-lg-6" }
const _hoisted_87 = { class: "col-lg-6" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = {
  key: 3,
  class: "row school"
}
const _hoisted_90 = { class: "col-lg-6" }
const _hoisted_91 = { class: "col-lg-6" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = {
  key: 4,
  class: "row school"
}
const _hoisted_94 = { class: "col-lg-6" }
const _hoisted_95 = { class: "col-lg-6" }
const _hoisted_96 = {
  key: 5,
  class: "row school"
}
const _hoisted_97 = { class: "col-lg-6" }
const _hoisted_98 = { class: "col-lg-6" }
const _hoisted_99 = {
  key: 6,
  class: "row school"
}
const _hoisted_100 = { class: "col-lg-6" }
const _hoisted_101 = { class: "col-lg-6" }
const _hoisted_102 = { class: "bg-gray fw-bold fs-6 p-3" }
const _hoisted_103 = {
  key: 0,
  class: "row px-3 fs-7 corporation"
}
const _hoisted_104 = { class: "col-lg-3" }
const _hoisted_105 = {
  key: 0,
  class: "col-lg-9 text-break"
}
const _hoisted_106 = {
  key: 1,
  class: "col-lg-9 text-break pre-line"
}
const _hoisted_107 = {
  key: 1,
  class: "row px-3 fs-7 corporation"
}
const _hoisted_108 = { class: "col-lg-3" }
const _hoisted_109 = {
  key: 0,
  class: "col-lg-9 text-break"
}
const _hoisted_110 = {
  key: 1,
  class: "col-lg-9 text-break pre-line"
}
const _hoisted_111 = {
  key: 2,
  class: "row px-3 fs-7 corporation"
}
const _hoisted_112 = { class: "col-lg-3" }
const _hoisted_113 = {
  key: 0,
  class: "col-lg-9 text-break"
}
const _hoisted_114 = {
  key: 1,
  class: "col-lg-9 text-break pre-line"
}
const _hoisted_115 = {
  key: 3,
  class: "row px-3 fs-7 corporation"
}
const _hoisted_116 = { class: "col-lg-3" }
const _hoisted_117 = {
  key: 0,
  class: "col-lg-9 text-break"
}
const _hoisted_118 = {
  key: 1,
  class: "col-lg-9 text-break pre-line"
}
const _hoisted_119 = {
  key: 4,
  class: "row px-3 fs-7 corporation"
}
const _hoisted_120 = { class: "col-lg-3" }
const _hoisted_121 = {
  key: 0,
  class: "col-lg-9 text-break"
}
const _hoisted_122 = {
  key: 1,
  class: "col-lg-9 text-break pre-line"
}
const _hoisted_123 = { class: "bg-white-50 pt-2 pb-5" }
const _hoisted_124 = { class: "d-flex mx-5 px-0 pb-3 border-bottom justify-content-center align-items-center" }
const _hoisted_125 = { class: "w-max-content me-4 col-form-label mt-1" }
const _hoisted_126 = { class: "d-flex mx-0 px-0 align-items-center" }
const _hoisted_127 = { class: "form-check m-0 me-4 d-flex align-items-center" }
const _hoisted_128 = ["for"]
const _hoisted_129 = ["id"]
const _hoisted_130 = { class: "form-check m-0 me-4 d-flex align-items-center" }
const _hoisted_131 = ["for"]
const _hoisted_132 = ["id"]
const _hoisted_133 = { class: "d-flex justify-content-center pt-4" }

import { computed, onMounted, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import dayjs from 'dayjs'

import Button from '@/components/button/index.vue'
import ConfirmModal from '@/views/community-admin/approval/approval-alumani-user-editing/components/ConfirmModal.vue'
import SuccessModal from '@/views/community-admin/approval/approval-alumani-user-editing/components/SuccessModal.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import { translate } from '@/languages/i18n'
import { COMMUNITY_ALUMNUS_CANDIDATES_STORE, REGISTER_STORE, COMMUNITY_STORE } from '@/store/constants'
import YelloopCheckInfo from '@/components/yelloop-check/YelloopCheckInfo.vue'

import { PREFECTURES } from '@/constants/index'
import { checkAdditionalInformationChoiceOptionDisplayData, getAdditionalInformationChoiceOptionDisplayDataOE30, normalizedDisplayText } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
// const hiddenTable = ref<boolean>(false)

const dataDetail = computed(() => store.getters[COMMUNITY_ALUMNUS_CANDIDATES_STORE.GETTERS.GET_CANDIDATE_DETAIL]?.candidateDetail)
const loadingDetail = computed(() => store.getters[COMMUNITY_ALUMNUS_CANDIDATES_STORE.GETTERS.GET_CANDIDATE_DETAIL]?.loadingDetail)
const dataError = computed(() => store.getters[COMMUNITY_ALUMNUS_CANDIDATES_STORE.GETTERS.GET_CANDIDATE_DETAIL]?.error)
const columnRequired = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])
const communityRequiredData = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])
const isShowFollowSetting = computed<boolean>(() => !!store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO]?.yelloop_check_enable)

const afterMount = ref<boolean>(false)
// const count = ref<number>(0)

onMounted(() => {
  store.dispatch(COMMUNITY_ALUMNUS_CANDIDATES_STORE.ACTIONS.SET_CANDIDATE_DETAIL, {
    id: router.currentRoute.value.params?.id,
    management_no: router.currentRoute.value.query?.management_no,
  })
  afterMount.value = true
  store.dispatch(REGISTER_STORE.ACTIONS.SET_COMMUNITY_REQUIRED_COLUMNS, {
    community_id: route.params?.id,
    params: { idAlumni: router.currentRoute.value.query?.management_no, userType: 'community_admin' },
  })
})

// watchEffect(() => {
//   console.log('watch effect running...')
//   if (columnRequired.value) {
//     const newArr = Object.keys(omit(columnRequired.value, 'id', 'community_id'))
//     newArr.map((e) => {
//       if (columnRequired.value[e] === 0) count.value++
//     })
//     // console.table(newArr)
//     console.table(columnRequired.value)
//     console.log('count', count.value)
//     console.log('newArr length', newArr.length)
//     if (newArr.length === count.value && newArr.length > 0) hiddenTable.value = true
//   }
// })

const ADDITIONAL_COLUMNS = {
  items: [
    'corporation_organization_name',
    'corporation_department_name',
    'corporation_start_period',
    'corporation_end_period',
    'corporation_employee_id',
    'corporation_email',
    'corporation_family_name',
    'corporation_given_name',
    'school_organization_name',
    'school_faclty_name',
    'school_department_name',
    'school_start_period',
    'school_end_period',
    'school_student_id',
    'school_email',
    'school_family_name',
  ],
  informations: ['additional_information_1', 'additional_information_2', 'additional_information_3', 'additional_information_4', 'additional_information_5'],
}

const showAdditional = (key) => {
  const columns = ADDITIONAL_COLUMNS[key]
  if (!columnRequired.value || !columns) return false
  return columns.some((field) => columnRequired.value[field])
}

const examinated = ref<boolean>(false)
const serverError = ref()

watchEffect(() => {
  examinated.value = dataDetail.value?.alumni_community_informations_examinated !== null ? dataDetail.value?.alumni_community_informations_examinated : true
})

const backToList = (): void => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/alumnus_candidates_waiting_approval?management_no=asc`)
}

const handleShowError = (status: string): void => {
  serverError.value = status
}

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('almunaiParManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('CI10breadcrumb'),
    to: `/community/communities/${route.params?.id}/alumnus_candidates_waiting_approval?management_no=asc`,
    active: false,
  },
  {
    content: translate('CI40breadcrumb'),
    to: '',
    active: true,
  },
]

watchEffect(() => {
  if (afterMount.value) {
    if (dataError.value) {
      router.replace(`/community/communities/${router.currentRoute.value.params?.id}/alumnus_candidates_waiting_approval?management_no=asc`)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    (!_unref(loadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('wattingAlmunaiUserDetail')), 1),
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(translate)('basicInformation')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('kanjiName')), 1),
              (_unref(dataDetail)?.family_name || _unref(dataDetail)?.given_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(dataDetail)?.family_name + ' ' + _unref(dataDetail)?.given_name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)('katakanaName')), 1),
              (_unref(dataDetail)?.family_name_kana || _unref(dataDetail)?.given_name_kana)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(dataDetail)?.family_name_kana + ' ' + _unref(dataDetail)?.given_name_kana), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(translate)('nickName')), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(dataDetail).display_name), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(translate)('email')), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(dataDetail).email), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(dayjs)(_unref(dataDetail).birthday).format('YYYY/MM/DD')), 1)
            ]),
            (_unref(dataDetail).zipcode_judgment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(translate)('zipcode')), 1),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(dataDetail).zipcode_foreign), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(translate)('zipcode')), 1),
                  (_unref(dataDetail).zipcode_1 && _unref(dataDetail).zipcode_2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(dataDetail).zipcode_1) + "-" + _toDisplayString(_unref(dataDetail).zipcode_2), 1))
                    : _createCommentVNode("", true)
                ])),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(translate)('address1')), 1),
              _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(PREFECTURES).find((item) => item.id == _unref(dataDetail).address_1)?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(translate)('address2')), 1),
              _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(dataDetail).address_2), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
              (_unref(dataDetail).phone_number_1 && _unref(dataDetail).phone_number_2 && _unref(dataDetail).phone_number_3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(dataDetail).phone_number_1) + "-" + _toDisplayString(_unref(dataDetail).phone_number_2) + "-" + _toDisplayString(_unref(dataDetail).phone_number_3), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("h3", _hoisted_35, _toDisplayString(_unref(translate)('currentPositionInfo')), 1),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(translate)('affiliation')), 1),
            _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(dataDetail).institution), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(translate)('occupation')), 1),
            _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(dataDetail).job_type_child), 1)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(translate)('affiliationPeriod')), 1),
            _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(dayjs)(_unref(dataDetail).enrollment_start_period).format('YYYY/M') + ' ' + _unref(translate)('SA20from') + ' ' + _unref(translate)('CI40current')), 1)
          ]),
          _createElementVNode("h3", _hoisted_45, _toDisplayString(_unref(translate)('obtainedApplicationTimeInfo')), 1),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(translate)('registrationRoute')), 1),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(UserAliasIcon, {
                userType: _unref(dataDetail)?.invited_community_management?.user_type
              }, null, 8, ["userType"]),
              ([1, 2].includes(_unref(dataDetail)?.invited_community_management?.user_type))
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_unref(dataDetail)?.invited_community_management?.management_no +
          ' ' +
          _unref(dataDetail)?.invited_community_management?.family_name +
          ' ' +
          _unref(dataDetail)?.invited_community_management?.given_name), 1))
                : _createCommentVNode("", true),
              ([1, 2].includes(_unref(dataDetail)?.invited_community_management?.user_type) && _unref(dataDetail)?.invited_community_management?.display_name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "（" + _toDisplayString(_unref(dataDetail)?.invited_community_management?.display_name) + "）", 1))
                : _createCommentVNode("", true),
              (_unref(dataDetail)?.invited_community_management?.user_type === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_unref(dataDetail)?.invited_community_management?.display_name), 1))
                : _createCommentVNode("", true),
              (_unref(dataDetail)?.invited_community_management?.user_type !== 0 && _unref(dataDetail)?.invited_route !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_unref(dataDetail)?.invited_route_name), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, _toDisplayString(_unref(translate)('applicationTime')), 1),
            _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(ConvertFromLocalTime)(_unref(dataDetail)?.alumni_community_information_created_at)), 1)
          ]),
          (showAdditional('items'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h3", _hoisted_56, _toDisplayString(_unref(translate)('OE30additionalItems')), 1),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    (_unref(columnRequired)?.corporation_organization_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(translate)('SA20corporationOrganizationName')), 1),
                          _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(dataDetail)?.corporation_organization_name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.corporation_department_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(translate)('enrolledDepartmentName')), 1),
                          _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(dataDetail)?.corporation_department_name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.corporation_start_period !== 0 && _unref(columnRequired)?.corporation_end_period !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, _toDisplayString(_unref(translate)('enrollment')), 1),
                          _createElementVNode("div", _hoisted_67, [
                            (_unref(dataDetail)?.corporation_start_period && _unref(dataDetail)?.corporation_end_period)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_unref(dayjs)(_unref(dataDetail)?.corporation_start_period).format('YYYY/M') + '～' + _unref(dayjs)(_unref(dataDetail)?.corporation_end_period).format('YYYY/M')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.corporation_employee_id !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, _toDisplayString(_unref(translate)('SA20employeeID')), 1),
                          _createElementVNode("div", _hoisted_71, _toDisplayString(_unref(dataDetail)?.corporation_employee_id), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.corporation_email !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(translate)('enrolledTimeEmailID')), 1),
                          _createElementVNode("div", _hoisted_74, _toDisplayString(_unref(dataDetail)?.corporation_email), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.corporation_family_name !== 0 && _unref(columnRequired)?.corporation_given_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(translate)('OE30nameAtTime')), 1),
                          _createElementVNode("div", _hoisted_77, _toDisplayString(_unref(dataDetail)?.corporation_family_name + ' ' + _unref(dataDetail)?.corporation_given_name), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    (_unref(columnRequired)?.school_organization_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, _toDisplayString(_unref(translate)('SA20schoolOrganizationName')), 1),
                          _createElementVNode("div", _hoisted_81, _toDisplayString(_unref(dataDetail)?.school_organization_name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.school_faclty_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, _toDisplayString(_unref(translate)('SA20facultyName')), 1),
                          _createElementVNode("div", _hoisted_84, _toDisplayString(_unref(dataDetail)?.school_faclty_name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.school_department_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                          _createElementVNode("div", _hoisted_86, _toDisplayString(_unref(translate)('SA20departmentName')), 1),
                          _createElementVNode("div", _hoisted_87, [
                            (_unref(dataDetail)?.corporation_start_period && _unref(dataDetail)?.corporation_end_period)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_unref(dataDetail)?.school_department_name), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.school_start_period !== 0 && _unref(columnRequired)?.school_end_period !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, _toDisplayString(_unref(translate)('SA20periodOfEnrollment')), 1),
                          _createElementVNode("div", _hoisted_91, [
                            (_unref(dataDetail)?.school_start_period && _unref(dataDetail)?.school_end_period)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(_unref(dayjs)(_unref(dataDetail)?.school_start_period).format('YYYY/M') + '～' + _unref(dayjs)(_unref(dataDetail)?.school_end_period).format('YYYY/M')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.school_student_id !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, _toDisplayString(_unref(translate)('SA20studentID')), 1),
                          _createElementVNode("div", _hoisted_95, _toDisplayString(_unref(dataDetail)?.school_student_id), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.school_email !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, _toDisplayString(_unref(translate)('SA20emailAttendSchool')), 1),
                          _createElementVNode("div", _hoisted_98, _toDisplayString(_unref(dataDetail)?.school_email), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(columnRequired)?.school_family_name !== 0 && _unref(columnRequired)?.school_given_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          _createElementVNode("div", _hoisted_100, _toDisplayString(_unref(translate)('SA20nameAtSchool')), 1),
                          _createElementVNode("div", _hoisted_101, _toDisplayString(_unref(dataDetail)?.school_family_name + ' ' + _unref(dataDetail)?.school_given_name), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(isShowFollowSetting))
            ? (_openBlock(), _createBlock(YelloopCheckInfo, {
                key: 1,
                "rejoin-intention": _unref(dataDetail)?.rejoin_intention,
                "desired-information": _unref(dataDetail)?.desired_information,
                is_waiting_approval: true
              }, null, 8, ["rejoin-intention", "desired-information"]))
            : _createCommentVNode("", true),
          (showAdditional('informations'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("h3", _hoisted_102, _toDisplayString(_unref(translate)('additionalInformation')), 1),
                _createElementVNode("div", null, [
                  (_unref(columnRequired)?.additional_information_1 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                        _createElementVNode("div", _hoisted_104, _toDisplayString(_unref(communityRequiredData).additional_information_1_question), 1),
                        (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.additional_information_1))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.additional_information_1), (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString(_unref(normalizedDisplayText)(_unref(dataDetail)?.additional_information_1)), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(columnRequired)?.additional_information_2 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, _toDisplayString(_unref(communityRequiredData).additional_information_2_question), 1),
                        (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.additional_information_2))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.additional_information_2), (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(_unref(normalizedDisplayText)(_unref(dataDetail)?.additional_information_2)), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(columnRequired)?.additional_information_3 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                        _createElementVNode("div", _hoisted_112, _toDisplayString(_unref(communityRequiredData).additional_information_3_question), 1),
                        (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.additional_information_3))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.additional_information_3), (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(_unref(normalizedDisplayText)(_unref(dataDetail)?.additional_information_3)), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(columnRequired)?.additional_information_4 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, _toDisplayString(_unref(communityRequiredData).additional_information_4_question), 1),
                        (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.additional_information_4))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.additional_information_4), (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_unref(normalizedDisplayText)(_unref(dataDetail)?.additional_information_4)), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(columnRequired)?.additional_information_5 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, _toDisplayString(_unref(communityRequiredData).additional_information_5_question), 1),
                        (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.additional_information_5))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.additional_information_5), (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_122, _toDisplayString(_unref(normalizedDisplayText)(_unref(dataDetail)?.additional_information_5)), 1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("label", _hoisted_125, _toDisplayString(_unref(translate)('examinationResult')), 1),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("label", {
                      class: "form-check-label mt-1",
                      for: _ctx.approve
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input me-2",
                        type: "radio",
                        value: true,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((examinated).value = $event)),
                        id: _ctx.approve,
                        name: "radio_result"
                      }, null, 8, _hoisted_129), [
                        [_vModelRadio, examinated.value]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('approval')), 1)
                    ], 8, _hoisted_128)
                  ]),
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("label", {
                      class: "form-check-label mt-1",
                      for: _ctx.reject
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input me-2",
                        type: "radio",
                        value: false,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((examinated).value = $event)),
                        id: _ctx.reject,
                        name: "radio_result"
                      }, null, 8, _hoisted_132), [
                        [_vModelRadio, examinated.value]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('rejection')), 1)
                    ], 8, _hoisted_131)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _createVNode(Button, {
                  title: _unref(translate)('back'),
                  type: 'secondary',
                  "class-name": 'me-5',
                  onClick: backToList
                }, null, 8, ["title"]),
                _createVNode(Button, {
                  title: _unref(translate)('confirm'),
                  "data-bs-toggle": 'modal',
                  type: 'secondary',
                  "data-bs-target": '#confirmModal'
                }, null, 8, ["title"])
              ])
            ])
          ]),
          _createVNode(ConfirmModal, {
            data: { ..._unref(dataDetail), examinated: examinated.value },
            handleShowError: handleShowError
          }, null, 8, ["data"]),
          _createVNode(SuccessModal, {
            data: { ..._unref(dataDetail), examinated: examinated.value },
            serverError: serverError.value
          }, null, 8, ["data", "serverError"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})